import type { ThreadsClientInterface, ThreadsGetParams, AssignPayload } from './threadsClient.types';
import BaseClient, { type BaseClientConfig, type ExtendedAxiosRequestConfig } from '../BaseClient';

export default class OrgUnitThreadsClient extends BaseClient implements ThreadsClientInterface {
    constructor(private teamId: number, private orgUnitId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getThreads(params?: ThreadsGetParams, config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/threads`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSummary(config?: ExtendedAxiosRequestConfig) {
        const url = `${this.apiBase}/teams/${this.teamId}/org-units/${this.orgUnitId}/threads/summary`;
        return this.makeCoreApiRequest(url, 'get', null, undefined, config);
    }

    setState(contactId: number, state: string, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit thread state changes');
        }
        const action = state === 'open' ? 'open' : 'close';
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/${action}`;
        return this.makeCoreApiRequest(url, 'post');
    }

    assignToSelf(contactId: number, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit thread assignment');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/claim`;
        return this.makeCoreApiRequest(url, 'post');
    }

    assignTo(contactId: number, payload: AssignPayload, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit thread assignment');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/assign`;
        return this.makeCoreApiRequest(url, 'post', payload);
    }

    unclaim(contactId: number, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit thread unclaim');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/unclaim`;
        return this.makeCoreApiRequest(url, 'post');
    }

    checkpointSave(contactId: number, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit checkpoint operations');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'post');
    }

    checkpointDelete(contactId: number, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit checkpoint operations');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    checkpointGet(contactId: number, groupId?: string) {
        if (!groupId) {
            throw new Error('groupId is required for OrgUnit checkpoint operations');
        }
        const url = `${this.apiBase}/teams/${this.teamId}/groups/${groupId}/contacts/${contactId}/thread/checkpoint`;
        return this.makeCoreApiRequest(url, 'get');
    }
}
